import type { ComponentLineProps } from "../../FirstPaymentPreview/types";
import { RawLines } from "../RawLines";

export const HeaderLine = ({ preview, options }: ComponentLineProps) => {
  if (!preview.future_payments) {
    return null;
  }

  return <RawLines.HeaderLine preview={preview} options={options} />;
};
